<template>
  <div>
    <div class="row text-white inner-row" style="background: #00bbff">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-minimal-up" v-on:click="changeView('toRow')" style="margin-right: 10px"></i>
        <b>{{'Дата выдачи: ' + convertDate(object.date)}}</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i class="tim-icons icon-pencil" v-on:click="changeView('toEdit')" style="margin-right: 10px"></i>
      </div>
    </div>

    <simple-row :name="'Дата выдачи'" :value="convertDate(object.date)"></simple-row>
    <simple-row :name="'Срок действия до'" :value="object.untilDate ? convertDate(object.untilDate) : 'бессрочно'"></simple-row>

    <simple-row :name="'Серия номер выдан'" :value="fieldView(object.series) + ' ' + fieldView(object.number) + ' ' + fieldView(object.gaveBy)"></simple-row>

    <ipr-tsrs v-if="showTSRs" :item="item.object" @hide="showTSRs = false"></ipr-tsrs>
    <p v-else> ТСР <i v-on:click="showTSRs = true" class="tim-icons icon-minimal-down"></i></p>

    <files v-if="showFiles" :item="item.object" :parent-type="'ipr'" @hide="showFiles = false"></files>
    <p v-else> Файлы <i v-on:click="showFiles = true" class="tim-icons icon-minimal-down"></i></p>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import {longAsStringDate} from "@/services/utils";

 export default {
   components: {
     SimpleRow
   },
   props:{
     item: {}
   },
   data() {
     return {
       tableKey: 0,
       object: this.item.object,
       showFiles: false,
       showTSRs: false
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     changeView(how) {
       this.$emit(how);
     }
   }
 }
</script>
<style>
</style>
